import React from 'react'

import { InventoryBuildingIcon } from 'components/Icons'

export const steps = [
  { text: 'Building', icon: InventoryBuildingIcon },
  {
    text: 'Receiver',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={22}
        height={23}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#a)'>
          <path
            d='M3.665 6.2H1.832v12.833c0 1.008.825 1.833 1.833 1.833H16.5v-1.833H3.665V6.2Zm14.667-3.667h-11a1.839 1.839 0 0 0-1.833 1.834v11c0 1.008.825 1.833 1.833 1.833h11a1.839 1.839 0 0 0 1.833-1.833v-11a1.839 1.839 0 0 0-1.833-1.834Zm-5.5 1.834a2.746 2.746 0 0 1 2.75 2.75 2.746 2.746 0 0 1-2.75 2.75 2.746 2.746 0 0 1-2.75-2.75 2.746 2.746 0 0 1 2.75-2.75Zm5.5 11h-11V13.99c0-1.824 3.667-2.75 5.5-2.75 1.833 0 5.5.926 5.5 2.75v1.376Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='a'>
            <path fill='#fff' transform='translate(0 .7)' d='M0 0h22v22H0z' />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    text: 'Method',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={22}
        height={23}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#a)'>
          <path
            d='M18.333 12.817H3.667a.92.92 0 0 0-.917.917v5.5a.92.92 0 0 0 .917.916h14.666a.92.92 0 0 0 .917-.916v-5.5a.92.92 0 0 0-.917-.917Zm-11.916 5.5a1.839 1.839 0 0 1-1.834-1.833c0-1.009.825-1.834 1.834-1.834 1.008 0 1.833.825 1.833 1.834a1.839 1.839 0 0 1-1.833 1.833ZM18.333 3.65H3.667a.92.92 0 0 0-.917.917v5.5a.92.92 0 0 0 .917.917h14.666a.92.92 0 0 0 .917-.917v-5.5a.92.92 0 0 0-.917-.917ZM6.417 9.15a1.839 1.839 0 0 1-1.834-1.833c0-1.008.825-1.833 1.834-1.833 1.008 0 1.833.825 1.833 1.833A1.839 1.839 0 0 1 6.417 9.15Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='a'>
            <path fill='#fff' transform='translate(0 .9)' d='M0 0h22v22H0z' />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    text: 'Brokers',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={22}
        height={23}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#a)'>
          <path
            d='M2.75 4.683v12.833c0 1.009.816 1.834 1.833 1.834h12.834a1.839 1.839 0 0 0 1.833-1.834V4.683a1.839 1.839 0 0 0-1.833-1.833H4.583A1.833 1.833 0 0 0 2.75 4.683Zm11 3.667A2.746 2.746 0 0 1 11 11.1a2.746 2.746 0 0 1-2.75-2.75A2.746 2.746 0 0 1 11 5.6a2.746 2.746 0 0 1 2.75 2.75ZM5.5 15.683c0-1.833 3.667-2.842 5.5-2.842 1.833 0 5.5 1.009 5.5 2.842v.917h-11v-.917Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='a'>
            <path fill='#fff' transform='translate(0 .1)' d='M0 0h22v22H0z' />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    text: 'Inventory',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={20}
        height={20}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='m18.865 15.955-4.327-4.326c-.44-.44-.907-.541-1.448-.541l-2.328 2.328c0 .541.1 1.018.54 1.449l4.327 4.326a.913.913 0 0 0 1.293 0l1.943-1.943a.913.913 0 0 0 0-1.293Z'
          fill='#2E2B2E'
        />
        <path
          d='M14.245 8a.913.913 0 0 0 1.293 0l.65-.651 1.944 1.943a2.75 2.75 0 0 0 0-3.887l-2.594-2.594a.913.913 0 0 0-1.293 0l-.65.651V1.134c0-.569-.697-.871-1.11-.459l-2.328 2.329c-.413.412-.11 1.109.458 1.109h2.329l-.651.65a.913.913 0 0 0 0 1.293l.32.321-2.649 2.65L6.197 5.24v-.916c0-.248-.101-.477-.266-.651l-1.852-1.86a.913.913 0 0 0-1.292 0l-1.302 1.3a.913.913 0 0 0 0 1.293l1.852 1.861a.907.907 0 0 0 .65.266h.917l3.786 3.786-.779.779H6.719c-.486 0-.953.192-1.292.54L1.1 15.966a.913.913 0 0 0 0 1.293L3.043 19.2a.913.913 0 0 0 1.293 0l4.327-4.326c.348-.349.54-.807.54-1.293V12.4l4.721-4.721.321.32Z'
          fill='#2E2B2E'
        />
      </svg>
    )
  },
  {
    text: 'Review',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width='22'
        height='23'
        viewBox='0 0 22 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_5135_9313)'>
          <path
            d='M13.1987 5.99935L12.9787 4.89935C12.8962 4.47768 12.5204 4.16602 12.0804 4.16602H5.4987C4.99453 4.16602 4.58203 4.57852 4.58203 5.08268V18.8327C4.58203 19.3368 4.99453 19.7493 5.4987 19.7493C6.00286 19.7493 6.41536 19.3368 6.41536 18.8327V13.3327H11.5487L11.7687 14.4327C11.8512 14.8635 12.227 15.166 12.667 15.166H17.4154C17.9195 15.166 18.332 14.7535 18.332 14.2493V6.91602C18.332 6.41185 17.9195 5.99935 17.4154 5.99935H13.1987Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='clip0_5135_9313'>
            <rect
              width='22'
              height='22'
              fill='white'
              transform='translate(0 0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
]

export const buyerSteps = [
  { text: 'Building', icon: InventoryBuildingIcon },
  {
    text: 'Receiver',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={22}
        height={23}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#a)'>
          <path
            d='M3.665 6.2H1.832v12.833c0 1.008.825 1.833 1.833 1.833H16.5v-1.833H3.665V6.2Zm14.667-3.667h-11a1.839 1.839 0 0 0-1.833 1.834v11c0 1.008.825 1.833 1.833 1.833h11a1.839 1.839 0 0 0 1.833-1.833v-11a1.839 1.839 0 0 0-1.833-1.834Zm-5.5 1.834a2.746 2.746 0 0 1 2.75 2.75 2.746 2.746 0 0 1-2.75 2.75 2.746 2.746 0 0 1-2.75-2.75 2.746 2.746 0 0 1 2.75-2.75Zm5.5 11h-11V13.99c0-1.824 3.667-2.75 5.5-2.75 1.833 0 5.5.926 5.5 2.75v1.376Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='a'>
            <path fill='#fff' transform='translate(0 .7)' d='M0 0h22v22H0z' />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    text: 'Buyers',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={22}
        height={23}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#a)'>
          <path
            d='M2.75 4.683v12.833c0 1.009.816 1.834 1.833 1.834h12.834a1.839 1.839 0 0 0 1.833-1.834V4.683a1.839 1.839 0 0 0-1.833-1.833H4.583A1.833 1.833 0 0 0 2.75 4.683Zm11 3.667A2.746 2.746 0 0 1 11 11.1a2.746 2.746 0 0 1-2.75-2.75A2.746 2.746 0 0 1 11 5.6a2.746 2.746 0 0 1 2.75 2.75ZM5.5 15.683c0-1.833 3.667-2.842 5.5-2.842 1.833 0 5.5 1.009 5.5 2.842v.917h-11v-.917Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='a'>
            <path fill='#fff' transform='translate(0 .1)' d='M0 0h22v22H0z' />
          </clipPath>
        </defs>
      </svg>
    )
  },
  {
    text: 'Inventory',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width={20}
        height={20}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='m18.865 15.955-4.327-4.326c-.44-.44-.907-.541-1.448-.541l-2.328 2.328c0 .541.1 1.018.54 1.449l4.327 4.326a.913.913 0 0 0 1.293 0l1.943-1.943a.913.913 0 0 0 0-1.293Z'
          fill='#2E2B2E'
        />
        <path
          d='M14.245 8a.913.913 0 0 0 1.293 0l.65-.651 1.944 1.943a2.75 2.75 0 0 0 0-3.887l-2.594-2.594a.913.913 0 0 0-1.293 0l-.65.651V1.134c0-.569-.697-.871-1.11-.459l-2.328 2.329c-.413.412-.11 1.109.458 1.109h2.329l-.651.65a.913.913 0 0 0 0 1.293l.32.321-2.649 2.65L6.197 5.24v-.916c0-.248-.101-.477-.266-.651l-1.852-1.86a.913.913 0 0 0-1.292 0l-1.302 1.3a.913.913 0 0 0 0 1.293l1.852 1.861a.907.907 0 0 0 .65.266h.917l3.786 3.786-.779.779H6.719c-.486 0-.953.192-1.292.54L1.1 15.966a.913.913 0 0 0 0 1.293L3.043 19.2a.913.913 0 0 0 1.293 0l4.327-4.326c.348-.349.54-.807.54-1.293V12.4l4.721-4.721.321.32Z'
          fill='#2E2B2E'
        />
      </svg>
    )
  },
  {
    text: 'Review',
    icon: (props) => (
      <svg
        style={props.iconStyle}
        width='22'
        height='23'
        viewBox='0 0 22 23'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_5135_9313)'>
          <path
            d='M13.1987 5.99935L12.9787 4.89935C12.8962 4.47768 12.5204 4.16602 12.0804 4.16602H5.4987C4.99453 4.16602 4.58203 4.57852 4.58203 5.08268V18.8327C4.58203 19.3368 4.99453 19.7493 5.4987 19.7493C6.00286 19.7493 6.41536 19.3368 6.41536 18.8327V13.3327H11.5487L11.7687 14.4327C11.8512 14.8635 12.227 15.166 12.667 15.166H17.4154C17.9195 15.166 18.332 14.7535 18.332 14.2493V6.91602C18.332 6.41185 17.9195 5.99935 17.4154 5.99935H13.1987Z'
            fill='#2E2B2E'
          />
        </g>
        <defs>
          <clipPath id='clip0_5135_9313'>
            <rect
              width='22'
              height='22'
              fill='white'
              transform='translate(0 0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    )
  }
]

export const InventoryReceiverOptions = ['Brokers', 'Buyers']
export const AllocationMethods = [
  {
    title: 'Individual Broker',
    icon: (
      <svg
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M0.167969 2.66667V21.3333C0.167969 22.8 1.35464 24 2.83464 24H21.5013C22.968 24 24.168 22.8 24.168 21.3333V2.66667C24.168 1.2 22.968 0 21.5013 0H2.83464C1.35464 0 0.167969 1.2 0.167969 2.66667ZM16.168 8C16.168 10.2133 14.3813 12 12.168 12C9.95464 12 8.16797 10.2133 8.16797 8C8.16797 5.78667 9.95464 4 12.168 4C14.3813 4 16.168 5.78667 16.168 8ZM4.16797 18.6667C4.16797 16 9.5013 14.5333 12.168 14.5333C14.8346 14.5333 20.168 16 20.168 18.6667V20H4.16797V18.6667Z'
          fill='#2E2B2E'
          fillOpacity='0.3'
        />
      </svg>
    )
  },
  {
    title: 'Multi Broker Competitive',
    icon: (
      <svg
        width='27'
        height='28'
        viewBox='0 0 27 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M18.8346 3.33366C18.8346 1.86699 20.0346 0.666992 21.5013 0.666992C22.968 0.666992 24.168 1.86699 24.168 3.33366C24.168 4.80033 22.968 6.00033 21.5013 6.00033C20.0346 6.00033 18.8346 4.80033 18.8346 3.33366ZM25.208 8.10699C24.0746 7.61366 22.8213 7.33366 21.5013 7.33366C20.608 7.33366 19.7546 7.46699 18.9413 7.70699C19.7146 8.44033 20.168 9.46699 20.168 10.5737V11.3337H26.8346V10.5737C26.8346 9.49366 26.1946 8.53366 25.208 8.10699ZM5.5013 6.00033C6.96797 6.00033 8.16797 4.80033 8.16797 3.33366C8.16797 1.86699 6.96797 0.666992 5.5013 0.666992C4.03464 0.666992 2.83464 1.86699 2.83464 3.33366C2.83464 4.80033 4.03464 6.00033 5.5013 6.00033ZM8.0613 7.70699C7.24797 7.46699 6.39464 7.33366 5.5013 7.33366C4.1813 7.33366 2.92797 7.61366 1.79464 8.10699C0.807969 8.53366 0.167969 9.49366 0.167969 10.5737V11.3337H6.83463V10.5737C6.83463 9.46699 7.28797 8.44033 8.0613 7.70699ZM10.8346 3.33366C10.8346 1.86699 12.0346 0.666992 13.5013 0.666992C14.968 0.666992 16.168 1.86699 16.168 3.33366C16.168 4.80033 14.968 6.00033 13.5013 6.00033C12.0346 6.00033 10.8346 4.80033 10.8346 3.33366ZM18.8346 11.3337H8.16797V10.5737C8.16797 9.49366 8.80797 8.53366 9.79463 8.10699C10.928 7.61366 12.1813 7.33366 13.5013 7.33366C14.8213 7.33366 16.0746 7.61366 17.208 8.10699C18.1946 8.53366 18.8346 9.49366 18.8346 10.5737V11.3337ZM17.5013 19.3337C17.5013 17.867 18.7013 16.667 20.168 16.667C21.6346 16.667 22.8346 17.867 22.8346 19.3337C22.8346 20.8003 21.6346 22.0003 20.168 22.0003C18.7013 22.0003 17.5013 20.8003 17.5013 19.3337ZM25.5013 27.3337H14.8346V26.5737C14.8346 25.4937 15.4746 24.5337 16.4613 24.107C17.5946 23.6137 18.848 23.3337 20.168 23.3337C21.488 23.3337 22.7413 23.6137 23.8746 24.107C24.8613 24.5337 25.5013 25.4937 25.5013 26.5737V27.3337ZM4.16797 19.3337C4.16797 17.867 5.36797 16.667 6.83463 16.667C8.3013 16.667 9.5013 17.867 9.5013 19.3337C9.5013 20.8003 8.3013 22.0003 6.83463 22.0003C5.36797 22.0003 4.16797 20.8003 4.16797 19.3337ZM12.168 27.3337H1.5013V26.5737C1.5013 25.4937 2.1413 24.5337 3.12797 24.107C4.2613 23.6137 5.51464 23.3337 6.83463 23.3337C8.15463 23.3337 9.40797 23.6137 10.5413 24.107C11.528 24.5337 12.168 25.4937 12.168 26.5737V27.3337ZM14.5013 15.3337V12.667H12.5013V15.3337H9.5013L13.5013 19.3337L17.5013 15.3337H14.5013Z'
          fill='#2E2B2E'
          fillOpacity='0.3'
        />
      </svg>
    )
  },
  {
    title: 'Multi Broker Sequenced',
    icon: (
      <svg
        width='28'
        height='20'
        viewBox='0 0 28 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M19.8372 10.0003C21.6772 10.0003 23.1572 8.50699 23.1572 6.66699C23.1572 4.82699 21.6772 3.33366 19.8372 3.33366C17.9972 3.33366 16.5039 4.82699 16.5039 6.66699C16.5039 8.50699 17.9972 10.0003 19.8372 10.0003ZM9.83724 8.66699C12.0506 8.66699 13.8239 6.88033 13.8239 4.66699C13.8239 2.45366 12.0506 0.666992 9.83724 0.666992C7.62391 0.666992 5.83724 2.45366 5.83724 4.66699C5.83724 6.88033 7.62391 8.66699 9.83724 8.66699ZM19.8372 12.667C17.3972 12.667 12.5039 13.8937 12.5039 16.3337V19.3337H27.1706V16.3337C27.1706 13.8937 22.2772 12.667 19.8372 12.667ZM9.83724 11.3337C6.73057 11.3337 0.503906 12.8937 0.503906 16.0003V19.3337H9.83724V16.3337C9.83724 15.2003 10.2772 13.2137 12.9972 11.707C11.8372 11.467 10.7172 11.3337 9.83724 11.3337Z'
          fill='#2E2B2E'
          fillOpacity='0.3'
        />
      </svg>
    )
  }
]
